"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ResponsiveManagerExample = void 0;
var tslib_1 = require("tslib");
var mithril_1 = tslib_1.__importDefault(require("mithril"));
var _1 = require("@/");
var examples_1 = require("@shared/examples");
var EXAMPLE_SRC = 'utils/responsive-manager/examples/index.ts';
var ResponsiveManagerExample = /** @class */ (function () {
    function ResponsiveManagerExample() {
    }
    ResponsiveManagerExample.prototype.view = function () {
        return (0, mithril_1.default)(examples_1.Example, { center: false, src: EXAMPLE_SRC }, [
            (0, mithril_1.default)('', [
                'Current screen size = ',
                _1.ResponsiveManager.is('xs') && 'XS',
                _1.ResponsiveManager.is('sm') && 'SM',
                _1.ResponsiveManager.is('md') && 'MD',
                _1.ResponsiveManager.is('lg') && 'LG',
                _1.ResponsiveManager.is('xl') && 'XL'
            ])
        ]);
    };
    return ResponsiveManagerExample;
}());
exports.ResponsiveManagerExample = ResponsiveManagerExample;
